module.exports = "<div class=\"dropletBubble-fieldContainer\">\n  <label class=\"dropletBubble-fieldLabel\">{{ option.label }}</label>\n  <input\n    class=\"dropletBubble-inputNumber\"\n    type=\"number\"\n    v-model=\"display[option.payload.models.value.name]\"\n    @keyup=\"changeCSS(option.payload)\" />\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/style-sidebar/options/input-number/template.html
// module id = U24w
// module chunks = 0